export default __webpack_public_path__ + "static/media/(52).6f9250b3.jpg";